"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsGetPlacementDetails = exports.googleAdsGetPlacementDetailsResultSchema = exports.googleAdsGetPlacementDetailsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsGetPlacementDetailsInputSchema = zod_1.z
    .object({
    customerId: zod_1.z
        .string()
        .nullish()
        .describe('ONLY provide if user explicitly specifies a Google Ads customer ID. DO NOT generate or guess customer IDs. Leave empty to automatically use the selected account. Must be provided by user - never invent random numbers.'),
    campaignId: zod_1.z
        .string()
        .nullish()
        .describe('Specific campaign ID to analyze. If not provided, returns data for all campaigns in the account.'),
    placementType: zod_1.z
        .enum(['SEARCH', 'DISPLAY', 'YOUTUBE', 'GMAIL', 'DISCOVER', 'ALL'])
        .nullish()
        .default('ALL')
        .describe('Filter by placement type. Defaults to ALL.'),
    startDate: zod_1.z
        .string()
        .nullish()
        .describe('Start date for performance data in YYYY-MM-DD format. e.g. 2025-08-01. If omitted, returns lifetime data.'),
    endDate: zod_1.z
        .string()
        .nullish()
        .describe('End date for performance data in YYYY-MM-DD format. e.g. 2025-08-31. If omitted, returns data up to today.'),
    metrics: zod_1.z
        .array(zod_1.z.enum(['impressions', 'clicks', 'cost', 'conversions', 'ctr', 'cpc', 'cpm']))
        .nullish()
        .default(['impressions', 'clicks', 'cost', 'ctr'])
        .describe('Metrics to include in the response. Defaults to basic metrics.'),
    maxItems: zod_1.z
        .number()
        .min(500)
        .default(500)
        .describe('The maximum number of placements to fetch. Unless specified, defaults to 500. Minimum is 500.'),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if no placement data is found. Unless specified, defaults to true.'),
        groupByDay: zod_1.z
            .boolean()
            .default(false)
            .describe('Group performance data by day. Unless specified, defaults to false.'),
    })
        .describe('Performance query options'),
})
    .describe('Get performance metrics by placement for Display, Video, and Performance Max campaigns. Shows which websites, apps, YouTube channels, or other placements perform best.');
exports.googleAdsGetPlacementDetailsArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsGetPlacementDetailsInputSchema);
var googleAdsGetPlacementDetailsResponseSchema = zod_1.z.array(zod_1.z.object({
    placement: zod_1.z
        .string()
        .describe('The placement identifier (website URL, app name, YouTube channel, etc.)'),
    placementType: zod_1.z
        .enum(['SEARCH', 'DISPLAY', 'YOUTUBE', 'GMAIL', 'DISCOVER', 'UNKNOWN'])
        .nullish()
        .describe('Type of placement'),
    campaignId: zod_1.z.string(),
    campaignName: zod_1.z.string().nullish(),
    performance: zod_1.z.object({
        impressions: zod_1.z.number().nullish(),
        clicks: zod_1.z.number().nullish(),
        cost: zod_1.z.number().nullish(),
        conversions: zod_1.z.number().nullish(),
        ctr: zod_1.z.number().nullish(),
        cpc: zod_1.z.number().nullish(),
        cpm: zod_1.z.number().nullish(),
        conversionRate: zod_1.z.number().nullish(),
    }),
    dailyBreakdown: zod_1.z
        .array(zod_1.z.object({
        date: zod_1.z.string(),
        impressions: zod_1.z.number().nullish(),
        clicks: zod_1.z.number().nullish(),
        cost: zod_1.z.number().nullish(),
    }))
        .nullish(),
}));
exports.googleAdsGetPlacementDetailsResultSchema = googleAdsGetPlacementDetailsResponseSchema;
exports.googleAdsGetPlacementDetails = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsGetPlacementDetails',
    displayName: 'Google Ads Placement Performance',
    displayDescription: 'Get performance metrics by placement for Display, Video, and Performance Max campaigns. Shows which websites, apps, YouTube channels, or other placements perform best. Automatically uses the selected account unless user provides specific customer ID.',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsGetPlacementDetailsArgsSchema,
}, googleAdsGetPlacementDetailsResponseSchema);
